module.exports = __webpack_public_path__ + "static/img/アセット 80@3x.4f58624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 80@3x.png
// module id = kdYH
// module chunks = 1